<template>
  <div>
    <div class="qr-code-box" id="qrcode" ref="qrcode"
         v-loading="payRes.payingLoading">
    </div>
    <div style="text-align: center;color: #fd5f39;font-size: 16px;margin-top: 10px;font-weight: bolder;"
         v-if="!!payRes.payStatusMsg">{{payRes.payStatusMsg}}
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import Stomp from 'stompjs'
import store from 'good-storage'

export default {
  name: 'PayTool',
  props: ['qrCodeUri'],
  data () {
    return {
      qrCode: null,
      payRes: {
        payingLoading: false,
        payStatusMsg: ''
      },
      stompClient: null,
      payingLoading: false,
      payStatusMsg: ''
    }
  },
  methods: {
    // 生成二维码
    initQRCode () {
      setTimeout(() => {
        if (this.qrCode) {
          this.qrCode.clear()
          this.qrCode.makeCode(this.qrCodeUri)
        } else {
          this.qrCode = new QRCode('qrcode', {
            width: 150,
            height: 150,
            text: this.qrCodeUri
          })
        }
      })
    },

    // rabbitMQ连接服务器
    connectMQ () {
      this.stompClient = Stomp.client('ws://134.175.126.154:15674/ws')
      this.stompClient.heartbeat = {
        outgoing: 0,
        incoming: 0
      }
      this.stompClient.connect('faker', 'faker', () => {
        this.subscribeMQ()
      }, () => {
        setTimeout(() => {
          this.connectMQ()
        }, 2000)
      }, 'recurit')
    },
    disConnectMQ () {
      if (this.stompClient) {
        this.stompClient.disconnect(() => {
          console.log('二维码关闭，断开RabbitMQ连接')
        })
        this.stompClient = null
      }
    },
    subscribeMQ () {
      let routingKey = store.get('user').userCode
      this.stompClient.subscribe(`/exchange/directxchange/${routingKey}`, (e) => {
        console.log(e)
        console.log('监听成功')
        if (e && e.body) {
          let res = JSON.parse(e.body)
          if (res && res.code === 200 && res.tradeStatus) {
            this.payResultHandle(res.tradeStatus)
          }
        }
      })
    },
    payResultHandle (resCode) {
      switch (resCode) {
        case 'WAIT_BUYER_PAY':
          this.payRes.payingLoading = true
          this.payRes.payStatusMsg = '已扫码，等待付款...'
          break
        case 'TRADE_CLOSED':
          this.payRes.payingLoading = false
          this.payRes.payStatusMsg = '未付款交易超时关闭，或支付完成后全额退款'
          setTimeout(() => this.stompClient.disconnect(), 500)
          break
        case 'TRADE_SUCCESS':
          this.payRes.payingLoading = false
          this.payRes.payStatusMsg = '支付成功'
          setTimeout(() => this.stompClient.disconnect(), 500)
          break
        case 'TRADE_FINISHED':
          this.payRes.payingLoading = false
          this.payRes.payStatusMsg = '交易结束，不可退款'
          setTimeout(() => this.stompClient.disconnect(), 500)
          break
        default:
          break
      }
    }
  },
  created () {
    this.initQRCode()
    this.connectMQ()
  }
}
</script>

<style scoped>
  .qr-code-box {
    width: 150px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/PayTool/PayTool.vue